var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccessibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.3393mm",
    height: "6.3393mm",
    viewBox: "0 0 6.3393 6.3393",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-.008352 -.26425)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 3.178,
    cy: 3.4339,
    r: 3.1696,
    fill: "#353535"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-89.06 -107.37)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.26458 0 0 .26458 89.051 107.1)",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.86058 0 0 .86058 1.6844 1.567)",
    "data-name": "Ebene 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h24v24h-24z",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#fffdfd"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 3.9,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10 19.9a2.9 2.9 0 0 1-3-3 2.9 2.9 0 0 1 2-2.8v-5.4h-4v1.5h2.3v2.5a5 5 0 0 0 2.7 9.2 5 5 0 0 0 4.9-4h-2.1a2.9 2.9 0 0 1-2.8 2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19 12.9v-2a6.2 6.2 0 0 1-4.1-1.8l-1.3-1.5a1.5 1.5 0 0 0-0.6-0.4 2.4 2.4 0 0 0-1.2-0.3 2.1 2.1 0 0 0-1.8 2.1v5.9a2 2 0 0 0 2 2h5v5h2v-5.5a2 2 0 0 0-2-2h-3v-3.4a8.8 8.8 0 0 0 5 1.9z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibility);
export default __webpack_public_path__ + "static/media/accessibility.d2ede51c5f6344ae8b8904cd428493d6.svg";
export { ForwardRef as ReactComponent };